import { useQuery } from "react-query";
import { fetchUserMovementPoints } from "../api/ContinuousLocationApi";

/**
 * Fetch the raw continuous-location point history for a user over a given
 * time window. The backend returns points sorted ascending by recorded_at,
 * admin-only, rate-limit-exempt (GET).
 */
export const useUserMovements = (userId, fromISO, toISO, options = {}) => {
  return useQuery(
    ["user-movements", userId, fromISO, toISO],
    fetchUserMovementPoints,
    {
      enabled: Boolean(userId),
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,
      ...options,
    }
  );
};
